import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LaformComponent } from './laform/laform.component';

const routes: Routes = [
  {
    path:'laform',
    component:LaformComponent,

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PierhipplaRoutingModule { }
